import { css } from 'styled-components';
import PluginCss from '!raw-loader!@egjs/react-flicking/dist/flicking.css';
export const FlickingCss = css `
  ${PluginCss};
`;
